// Shows the Engine password policy next to the password fields. The policy
// itself is enforced server-side by Eui::User.
const PasswordRequirements = () => (
  <div className="form-group">
    <div className="col-sm-offset-4 col-sm-8">
      <p className="help-block">{ t("phrases.engine_password_requirements") }</p>
    </div>
  </div>
);

export default PasswordRequirements;
